/**
 * Todo valor editable sabe de dónde viene (doc. 03 §2): ingresado, supuesto, importado o
 * calibrado. Los resultados calculados viven en otra entidad y nunca se mezclan con estos.
 */

export type OrigenDato = 'ingresado' | 'supuesto' | 'importado' | 'calibrado';

export interface Parametro<T> {
  valor: T;
  /** Unidad visible junto al valor: «min», «autos/día», «%», «km/h», «s», «hh:mm»… */
  unidad: string;
  origen: OrigenDato;
  nota?: string;
  /**
   * Valor supuesto (de la plantilla o del perfil) que había antes de editarlo. Permite «volver al
   * supuesto». Solo existe mientras el valor no es el supuesto.
   */
  supuesto?: T;
}

export function supuesto<T>(valor: T, unidad: string, nota?: string): Parametro<T> {
  return nota === undefined
    ? { valor, unidad, origen: 'supuesto' }
    : { valor, unidad, origen: 'supuesto', nota };
}

export function ingresado<T>(valor: T, unidad: string, nota?: string): Parametro<T> {
  return nota === undefined
    ? { valor, unidad, origen: 'ingresado' }
    : { valor, unidad, origen: 'ingresado', nota };
}
